import { StripeElements } from "@stripe/stripe-js";

const cardFields = [
  {
    name: "cardNumber",
    emptyError: "Please enter card number",
    invalidError: "Invalid card number",
    type: "CardNumber",
  },
  {
    name: "cardExpiry",
    emptyError: "Please enter card expiry date",
    invalidError: "Invalid card expiry date",
    type: "CardExpiry",
  },
  {
    name: "cardCvc",
    emptyError: "Please enter cvc",
    invalidError: "Invalid cvc",
    type: "CardCvc",
  },
];

export function isValidCard(elements: StripeElements | null) {
  const validateField = (field: {
    name: string;
    emptyError: string;
    invalidError: string;
    type: string;
  }) => {
    const element = elements?.getElement(field.name as any);
    if (element?._empty) {
      return {
        type: `empty${field.type}Error`,
        message: field.emptyError,
        isValid: false,
      };
    }
    if (element?._invalid) {
      return {
        type: `invalid${field.type}Error`,
        message: field.invalidError,
        isValid: false,
      };
    }
    return null;
  };

  for (const field of cardFields) {
    const validationError = validateField(field);
    if (validationError) {
      return validationError;
    }
  }

  return { type: "", message: "", isValid: true };
}

export const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}).format;
